import script from "./ServiceInvoicePayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceInvoicePayments.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceInvoicePayments.vue?vue&type=style&index=0&id=952c9a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-952c9a8e"]])

export default __exports__